import React from 'react';
import { usePageContent } from '../../hooks/usePageContent';
import styles from './index.module.css';

const fmt = (val) => (val != null ? `$${Number(val).toLocaleString()}` : null);

const SlimlineNote = ({ item, c, noteOverride }) => {
  const note = noteOverride !== undefined ? noteOverride : item.slimlineNote;
  if (note) return <div style={{ whiteSpace: 'pre-line' }}>{note}</div>;
  if (item.slimlineAddon != null) {
    return <div>{c.slimlineExtraPrefix || 'Slimline extra'} {fmt(item.slimlineAddon)} {c.slimlineExtreSuffix || 'per plate'}</div>;
  }
  return null;
};

const PriceListPage = () => {
  const [showAll, setShowAll] = React.useState(false);
  const { find } = usePageContent('price-list');
  const c = find('priceList') || {};

  const items = c.items || [];
  const initialVisible = c.initialVisible ?? 5;

  return (
    <div id="content">
      <div className="page-header">
        <div className="container">
          <h1 className="page-header__title">{c.pageTitle || 'Prices'}</h1>
        </div>
      </div>

      <div className="content-holder content-holder--indented">
        <div className="component rich-text">
          <div className="component-content" dangerouslySetInnerHTML={{ __html: c.summary }}>
          </div>
        </div>
        <div className={styles.priceList}>
          {items.map((item, i) => {
            const hidden = !showAll && i >= initialVisible;
            return (
              <div
                key={item.id}
                className={`${styles.priceListItem} ${hidden ? styles.priceListItemHidden : ''}`}
              >
                <h2 className={styles.priceListTitle}>
                  <a href={`/browse-styles/${item.slug || item.id}`}>{item.name}</a>
                </h2>
                <div className={styles.priceListData}>
                  <div className={styles.priceListImage}>
                    <a href={`/browse-styles/${item.slug || item.id}`}>
                      <img src={item.image} alt={item.name} />
                    </a>
                  </div>

                  <div className={styles.priceListNew}>
                    <h3 className={styles.priceListSubhead}>{c.newPlatesHeading || 'New Plates'}</h3>
                    <h4 className={styles.priceListPriceTitle}>{c.priceSubheading || 'Price'}</h4>
                    {item.newPriceLines
                      ? item.newPriceLines.map((line, j) => (
                          <div key={j}>{line.text !== undefined ? line.text : <>{fmt(line.price)}{item.priceAsterisk ? '*' : ''} {line.label}</>}</div>
                        ))
                      : (() => {
                          const hasNew = fmt(item.newPrice) != null;
                          const hasRestyle = fmt(item.restylePrice) != null;
                          const showLabels = hasNew && hasRestyle;
                          const rows = item.newPriceFirst
                            ? [
                                hasNew && <div key="new">{fmt(item.newPrice)}{item.priceAsterisk ? '*' : ''}{showLabels ? ` ${c.newLabel || 'New'}` : ''}</div>,
                                hasRestyle && <div key="restyle">{fmt(item.restylePrice)}{item.priceAsterisk ? '*' : ''}{showLabels ? ` ${c.restyleLabel || 'Restyle'}` : ''}</div>,
                              ]
                            : [
                                hasRestyle && <div key="restyle">{fmt(item.restylePrice)}{item.priceAsterisk ? '*' : ''}{showLabels ? ` ${c.restyleLabel || 'Restyle'}` : ''}</div>,
                                hasNew && <div key="new">{fmt(item.newPrice)}{item.priceAsterisk ? '*' : ''}{showLabels ? ` ${c.newLabel || 'New'}` : ''}</div>,
                              ];
                          return <>{rows}</>;
                        })()
                    }
                    <SlimlineNote item={item} c={c} />
                  </div>

                  <div className={styles.priceListReplacement}>
                    <h3 className={styles.priceListSubhead}>{c.replacementHeading || 'Replacement plates'}</h3>
                    <div className={styles.priceListReplacementItems}>
                      <div className={styles.priceListReplacementItem}>
                        <h4 className={styles.priceListPriceTitle}>{c.onePlateLabel || 'One plate'}</h4>
                        {fmt(item.replacementOne) && <div>{fmt(item.replacementOne)}{item.priceAsterisk ? '*' : ''}{item.replacementOneQualifier ? ` ${item.replacementOneQualifier}` : ''}</div>}
                        <SlimlineNote item={item} c={c} noteOverride={item.replacementSlimlineNote} />
                      </div>
                      <div className={styles.priceListReplacementItem}>
                        <h4 className={styles.priceListPriceTitle}>{c.twoPlatesLabel || 'Two plates'}</h4>
                        {fmt(item.replacementTwo)
                          ? <><div>{fmt(item.replacementTwo)}{item.priceAsterisk ? '*' : ''}{item.replacementTwoQualifier ? ` ${item.replacementTwoQualifier}` : ''}</div><SlimlineNote item={item} c={c} noteOverride={item.replacementSlimlineNote} /></>
                          : item.replacementTwoNote
                          ? <div>{item.replacementTwoNote}</div>
                          : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {!showAll && items.length > initialVisible && (
          <div className={styles.priceListActions}>
            <button
              type="button"
              className={styles.loadMoreBtn}
              onClick={() => setShowAll(true)}
            >
              {c.loadMoreText || 'Load more'}
            </button>
          </div>
        )}

        <div className={styles.giftVouchers}>
          <h3 className={styles.giftVouchersTitle}>{c.giftVouchersTitle || 'Gift Vouchers'}</h3>
          <div className={styles.giftVouchersBody}>
            <img
              src={c.giftVouchersImageSrc || '/images/price-list/giftcard.png'}
              alt={c.giftVouchersImageAlt || 'Gift Card'}
              width={250}
              height={155}
            />
            {c.giftVouchersHtml
              ? <div dangerouslySetInnerHTML={{ __html: c.giftVouchersHtml }} />
              : <p>Looking for something a little different for a birthday or Christmas gift?{' '}<a href="/gift-vouchers">Here&apos;s where you can find out more</a>.</p>
            }
          </div>
        </div>


        <p className={styles.disclaimer} dangerouslySetInnerHTML={{ __html: c.disclaimer }}>
        </p>
      </div>
    </div>
  );
};

export default PriceListPage;
